module.exports = __webpack_public_path__ + "static/media/icon_orden_descendente.6e4ec0bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_orden_descendente.svg
// module id = 339
// module chunks = 0